import { ActionsSubject } from '@ngrx/store';
import { Injectable } from '@angular/core';

@Injectable()
export class DevtoolsDispatcher extends ActionsSubject {}
